<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-finanziamenti page-operative-data-analysis-finanziamenti-new">
    <div class="container">
      <div class="d-flex align-items-center justify-content-between mb-5">
        <PageTitle>Nuovo finanziamento</PageTitle>
        <app-router-link class="btn btn-outline-primary" :to="{ name: 'operative-company.data-analysis.finanziamenti' }">Torna alla lista</app-router-link>
      </div>

      <FormFinanziamento @saved="saveFinanziamento" />
    </div>
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-finanziamenti-new',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle'),
    FormFinanziamento: () => import('@/views/components/Operative/Form/FormFinanziamento'),
    AppRouterLink: () => import('@/views/components/Layout/AppRouterLink'),
  },
  methods: {
    saveFinanziamento (finanziamento) {
      this.$api.addFinanziamento(this.company.id, finanziamento)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.finanziamenti',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
};

</script>
